import { render, staticRenderFns } from "./ManifestTable.vue?vue&type=template&id=176518ed&scoped=true"
import script from "./ManifestTable.vue?vue&type=script&lang=ts"
export * from "./ManifestTable.vue?vue&type=script&lang=ts"
import style0 from "./ManifestTable.vue?vue&type=style&index=0&id=176518ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176518ed",
  null
  
)

export default component.exports